export default __webpack_public_path__ + "static/media/portfolioV1.e9eb8049.gif";